import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { openInNewTab } from 'srcReact/helpers/utils'
import SidebarMenu from './components/SidebarMenu'
import MobileHeader from './components/MobileHeader'
import Display from './components/Display'
import Workplaces from './components/Workplaces'
import LeadershipTeam from './components/LeadershipTeam'
import Members from './components/Members'
import YourPlan from './components/YourPlan'
import Invoices from './components/Invoices'
import { checkNested } from 'srcReact/helpers/validator'
import { commonActions } from 'srcReact/components'
import { redirectToPage } from 'srcReact/helpers/history'
import { organizationSettingsActions } from 'srcReact/OrganizationSettingsPage'
import queryString from 'query-string'
import OrgDocuments from './components/OrgDocuments'
import IntegrationSettings from 'srcReact/Pages/IntegrationSettings'

const OrganizationSettingsPage = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    common: { isMobile, isNative },
    organization: {
      current_organization,
      header: { user_properties, subscription }
    },
    organizationSettings: { hosted_page }
  } = useSelector((state) => state)
  const [activeItem, setActiveItem] = useState(
    isMobile ? t('organizationSettings.title') : t('organizationSettings.display.title')
  )

  useEffect(() => {
    dispatch(commonActions.getCurrencyList(1))
    const { active_tab } = queryString.parse(location.search)
    if (active_tab === 'members') {
      setActiveItem(t('organizationSettings.deleteRequest.title'))
    }
  }, [])
  useEffect(() => {
    if (checkNested(current_organization, 'info', 'id')) {
      if (!current_organization.info.editable) redirectToPage('/0/myhome', isNative)
      if (current_organization.info.editable)
        dispatch(organizationSettingsActions.getPaymentInformationUrl(current_organization.info.id))
    }
  }, [current_organization && current_organization.info && current_organization.info.id])

  const renderMainContent = () => {
    switch (activeItem) {
      case t('organizationSettings.display.title'):
        return <Display />
      case t('organizationSettings.workplaces.title'):
        return <Workplaces />
      case t('organizationSettings.leadershipTeam.title'):
        return <LeadershipTeam />
      case t('global.members'):
        return <Members />
      case t('organizationSettings.deactivatedMembers.title'):
        return <Members deactivated={1} requestToDelete={0} />
      case t('organizationSettings.deleteRequest.title'):
        return <Members requestToDelete={1} deactivated={0} />
      case t('organizationSettings.yourPlan.title'):
        return <YourPlan />
      case t('organizationSettings.invoices.title'):
        return <Invoices />
      case t('organizationSettings.documents.title'):
        return <OrgDocuments />
      case t('integration.title2'):
        return <IntegrationSettings from='org_settings' />
    }
  }
  const handleActiveItem = (item) => {
    if (item === t('organizationSettings.paymentInformation.title')) return openInNewTab(hosted_page.url)
    setActiveItem(item)
  }
  const listItems = [
    {
      heading: isMobile ? t('organizationSettings.general.title') : t('organizationSettings.title'),
      items: [
        t('organizationSettings.display.title'),
        t('organizationSettings.workplaces.title'),
        t('organizationSettings.leadershipTeam.title'),
        t('global.members'),
        t('organizationSettings.deactivatedMembers.title'),
        t('organizationSettings.deleteRequest.title'),
        t('organizationSettings.documents.title'),
        t('integration.title2')
      ]
    }
  ]
  if (!!user_properties?.organization.with_subscription && subscription?.plan?.id?.includes('free')) {
    listItems.push({
      heading: t('organizationSettings.billing.title'),
      items: [t('organizationSettings.yourPlan.title'), t('organizationSettings.invoices.title')]
    })
  } else if (!!user_properties?.organization.with_subscription) {
    listItems.push({
      heading: t('organizationSettings.billing.title'),
      items: [
        t('organizationSettings.yourPlan.title'),
        t('organizationSettings.invoices.title'),
        t('organizationSettings.paymentInformation.title')
      ]
    })
  }

  return (
    <PageContainer
      pageClassName={styles.organizationSettingsWrapper}
      pageTitle={t('organizationSettings.title')}
      withFooter={false}>
      {isMobile && <MobileHeader activeItem={activeItem} setActiveItem={setActiveItem} />}

      {((isMobile && activeItem === t('organizationSettings.title')) || !isMobile) && (
        <div className={styles.sidebarMenu}>
          <SidebarMenu
            isMobile={isMobile}
            listItems={listItems}
            activeItem={activeItem}
            setActiveItem={handleActiveItem}
          />
        </div>
      )}

      {activeItem !== t('organizationSettings.title') && (
        <main className={styles.mainContent}>{renderMainContent()}</main>
      )}
    </PageContainer>
  )
}

export { OrganizationSettingsPage }
